<template>
  <div>
    <b-button v-b-modal.modalAdvancedLabelExport><b-spinner small v-if="generatingLabels"></b-spinner>
    <font-awesome-icon icon="file-pdf" size="1x" />&nbsp;&nbsp;<translate>Advanced label bulk export</translate></b-button>

    <b-modal id="modalAdvancedLabelExport" size="lg" ref="modalAdvancedLabelExport" hide-footer @hide="clearAdvanceSearch">
      <div slot="modal-title" v-translate>Advanced Label Bulk Export</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <p class="mb-4" v-translate>Please, select a date range and at least one shipping status to generate all matching shipping labels in only one PDF file. Once the generation job is done you will receive an email with the PDF download link.</p>
      <b-form @submit.prevent="dispatchLabelGeneration">
        <b-row class="mb-3">
          <b-col cols="4">
            <label class="" for="inline-form-input-name" v-translate>Select Date Range </label><label v-show="dateRangeActive === true">&nbsp;[<a href="#" @click.prevent="resetDateRange">reset range</a>]</label>
            <date-range-picker
              v-if="this.locale.daysOfWeek"
              v-model="dateRange"
              @update="dateRangeActive = true"
              :locale-data="{...locale}"
              :opens="opens"
              class="mb-2 w-100"
              :ranges="ranges"
            >
              <div slot="input" slot-scope="picker" style="top: 3px;position:relative">
                <font-awesome-icon :icon="['far', 'calendar-alt']" size="1x" style="vertical-align: middle" />
                <span v-if="!dateRangeActive" style="vertical-align: middle">...</span>
                <span v-else style="vertical-align: middle">{{moment(dateRange.startDate).format('L')}} - {{moment(dateRange.endDate).format('L')}}</span>
              </div>
            </date-range-picker>

          </b-col>
          <b-col cols="4">
            <label for="shipping-status" class="sr-onsly mr-2" v-translate>Shippings' Statuses</label>
            <b-form-checkbox-group stacked id="shipping-status" v-model="advancedSearchStatus">
              <b-form-checkbox value="DRAFT"><translate>Received by the system</translate></b-form-checkbox>
              <b-form-checkbox value="READYATSTORE"><translate>Ready at store</translate></b-form-checkbox>
              <b-form-checkbox value="READY"><translate>Ready to be scheduled</translate></b-form-checkbox>
            </b-form-checkbox-group>
          </b-col>
          <b-col cols="4">
            <label for="shipping-status" class="sr-onsly mr-2" v-translate>Sort labels by</label>
            <b-form-radio-group stacked id="shipping-status" v-model="sort">
              <b-form-radio :value="[{key: 'created_at', direction: 'asc'}]"><translate>Shipping creation date</translate></b-form-radio>
              <b-form-radio :value="[{key: 'to_contact', direction: 'asc'}]"><translate>Addressee name</translate></b-form-radio>
            </b-form-radio-group>
          </b-col>
        </b-row>
        <b-row class="align-middle">
          <b-col cols="12">
            <b-button type="submit" :disabled="!dateRangeActive || advancedSearchStatus.length === 0" variant="primary" v-translate>Generate labels</b-button>
            <b-button variant="link" @click.prevent="clearAdvanceSearch" v-translate>Reset selection</b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>

  </div>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker'

export default {
  name: 'AdvancedLabelExportForm',
  components: {
    DateRangePicker
  },
  data() {
    return {
      params: {
        filter_groups: []
      },
      advancedSearchStatus: [],
      sort: [
        {
          key: 'created_at',
          direction: 'asc'
        }
      ],
      advancedSearchDateRange: {},
      dateRange: { // used for v-model prop
        startDate: this.moment().toDate(),
        endDate: this.moment().toDate()
      },
      dateRangeActive: false,
      opens: 'right', //  which way the picker opens, default "center", can be "left"/"right"
      locale: {},
      ranges: { //  default value for ranges object (if you set this to false ranges will no be rendered)
        [this.$gettext('Today')]: [this.moment().toDate(), this.moment().toDate()],
        [this.$gettext('Yesterday')]: [this.moment().subtract(1, 'days').toDate(), this.moment().subtract(1, 'days').toDate()],
        [this.$gettext('Last 7 days')]: [this.moment().subtract(6, 'day').startOf('day').toDate(), this.moment().subtract(0, 'day').toDate()],
        [this.$gettext('Last 30 days')]: [this.moment().subtract(29, 'day').startOf('day').toDate(), this.moment().subtract(0, 'day').toDate()],
        [this.$gettext('This month')]: [this.moment().startOf('month').toDate(), this.moment().local().endOf('month').toDate()],
        [this.$gettext('This year')]: [this.moment().startOf('year').toDate(), this.moment().local().endOf('year').toDate()],
        [this.$gettext('Last week')]: [this.moment().subtract(1, 'week').startOf('week').toDate(), this.moment().subtract(1, 'week').local().endOf('week').toDate()],
        [this.$gettext('Last month')]: [this.moment().subtract(1, 'month').startOf('month').toDate(), this.moment().subtract(1, 'month').local().endOf('month').toDate()]
      },
      datepickerLocalized: false,
      generatingLabels: false
    }
  },
  mounted() {
    this.initDatePicker()
  },
  methods: {
    initDatePicker() {
      this.locale = {
        direction: 'ltr',
        format: 'dd/mm/yyyy',
        separator: ' - ',
        applyLabel: this.$gettext('Apply'),
        cancelLabel: this.$gettext('Cancel'),
        weekLabel: 'W',
        customRangeLabel: 'Custom Range',
        daysOfWeek: this.moment.weekdaysMin(),
        monthNames: this.moment.monthsShort(),
        firstDay: this.moment().day(0) === this.moment().local().weekday(0) ? 0 : 1,
        showWeekNumbers: false
      }
      this.ranges = { //  default value for ranges object (if you set this to false ranges will no be rendered)
        [this.$gettext('Today')]: [this.moment().toDate(), this.moment().toDate()],
        [this.$gettext('Yesterday')]: [this.moment().subtract(1, 'days').toDate(), this.moment().subtract(1, 'days').toDate()],
        [this.$gettext('Last 7 days')]: [this.moment().subtract(6, 'day').startOf('day').toDate(), this.moment().subtract(0, 'day').toDate()],
        [this.$gettext('Last 30 days')]: [this.moment().subtract(29, 'day').startOf('day').toDate(), this.moment().subtract(0, 'day').toDate()],
        [this.$gettext('This month')]: [this.moment().startOf('month').toDate(), this.moment().local().endOf('month').toDate()],
        [this.$gettext('This year')]: [this.moment().startOf('year').toDate(), this.moment().local().endOf('year').toDate()],
        [this.$gettext('Last week')]: [this.moment().subtract(1, 'week').startOf('week').toDate(), this.moment().subtract(1, 'week').local().endOf('week').toDate()],
        [this.$gettext('Last month')]: [this.moment().subtract(1, 'month').startOf('month').toDate(), this.moment().subtract(1, 'month').local().endOf('month').toDate()]
      }
      this.datepickerLocalized = true
    },
    resetDateRange() {
      this.dateRange = {
        startDate: this.moment().toDate(),
        endDate: this.moment().toDate()
      }
      this.dateRangeActive = false
    },
    dispatchLabelGeneration() {
      this.generatingLabels = true
      this.params.sort = this.sort

      if (this.advancedSearchStatus.length > 0) {
        this.params.filter_groups[0] = {
          filters: [{
            key: 'status',
            value: this.advancedSearchStatus,
            operator: 'in'
          }]
        }
      } else {
        this.params.filter_groups[0] = {}
      }

      if (this.dateRangeActive) {
        this.params.filter_groups[1] = {
          filters: [{
            key: 'created_at',
            value: this.moment(this.dateRange.startDate).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss'),
            operator: 'gte'
          },
          {
            key: 'created_at',
            value: this.moment(this.dateRange.endDate).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss'),
            operator: 'lte'
          }]
        }
      } else {
        this.params.filter_groups[1] = {}
      }
      this.params.filter_groups[2] = {
        filters: [
          ['company_id', 'eq', this.$store.getters.profile.company_id]
        ]
      }
      if (
        this.$store.getters.profile.company.settings.findIndex(x => x.name === 'label_wrong_address') === -1 ||
        (
          this.$store.getters.profile.company.settings.findIndex(x => x.name === 'label_wrong_address') !== -1 &&
          this.$store.getters.profile.company.settings.find(x => x.name === 'label_wrong_address').pivot.value === '0'
        )
      ) {
        this.params.filter_groups[2].filters[1] = ['fields_revision', 'eq', 1, 'true']
      }
      this.params.format = 'upload'
      this.$http.get(this.$appConfig.api.baseUrl + 'shippings/labels', { params: this.params })
        .then(response => {
          this.$refs.modalAdvancedLabelExport.hide()
          this.clearAdvanceSearch()
          const obj = {
            title: this.$gettext('JOB DISPATCHED'),
            message: this.$gettext('The Bulk Label PDF is being generated, you will receive an email with a link to download it as soon as it\'s done'),
            type: 'success',
            customCloseBtnText: this.$gettext('Close')
          }
          this.$root.$children[0].$refs.simplert.openSimplert(obj)
          this.generatingLabels = false
        })
    },
    clearAdvanceSearch() {
      this.advancedSearchStatus = []
      this.dateRange = {
        startDate: this.moment(),
        endDate: this.moment()
      }
      this.dateRangeActive = false
      this.params.filter_groups = []
    }
  }
}
</script>
